module.exports = __webpack_public_path__ + "img/0x165DBb08de0476271714952C3C1F068693bd60D7.f67776a2.png";